import { history } from '@umijs/max';

/**
 * 从 postMessage 消息中解析路径和参数，并进行路由跳转
 * @param messageData 消息数据，包含 path 和 params
 * @param currentSearchParams 当前的 URLSearchParams，用于合并参数
 */
export function navigateFromMessage(
  messageData: { path?: string; params?: Record<string, string> },
  currentSearchParams: URLSearchParams
): void {
  const { path, params } = messageData;

  // 如果没有 path，则不进行跳转
  if (!path) {
    console.warn('navigateFromMessage: path 为空，无法跳转');
    return;
  }

  // 创建新的 URLSearchParams，先复制当前的参数
  const newSearchParams = new URLSearchParams(currentSearchParams);

  // 合并新的参数
  if (params && typeof params === 'object') {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        newSearchParams.set(key, String(value));
      } else {
        // 如果值为空，则删除该参数
        newSearchParams.delete(key);
      }
    });
  }

  // 构建完整的路径，包含查询参数
  const queryString = newSearchParams.toString();
  const fullPath = queryString ? `${path}?${queryString}` : path;

  // 使用 history.push 进行路由跳转
  history.push(fullPath);
}

